import { InputHTMLAttributes } from "react"
import { useFormContext } from "react-hook-form"
import Field from "./Field"
import clsx from "clsx"

interface InputProps {
  name: string
  label?: string
  className?: string
}

const Input = ({
  name,
  label,
  className,
  ...rest
}: InputProps & InputHTMLAttributes<HTMLInputElement>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext()

  return (
    <Field label={label} name={name} errors={errors}>
      <input
        id={name}
        className={clsx(
          "h-10 w-full rounded border-0 bg-gray-800 px-2 text-base text-white outline-none focus:border-0",
          className
        )}
        {...register(name)}
        {...rest}
      />
    </Field>
  )
}

export default Input
